import React from 'react'
import './intro.css'
import img1 from '../../assets/comp1.jpeg'
import img2 from '../../assets/comp2.jpeg'

const Intro = () => {
  return (
    <section id="hero">
      <div className="container">
        <div className="heroContent">
          <div className="comp-philosophy">
            <h1>عن المؤسسة</h1>
            <h3>ما نمثله</h3>
            <p>
              مؤسسة رؤى الآفاق هي مؤسسة مقاولات متخصصة في الأعمال الكهربائية
              والاتصالات و تسعى مؤسسة رؤى الافاق الى تنفيذ الأعمال بأعلى
              المواصفات الهندسية وتعتمد المؤسسة على كوادر من أكفاء المهندسين
              والفنيين والإداريين ذوي الخبرة والنزاهة لتنفيذ الاعمال باعلى مهنية
              ممكنه ونظرا لطبيعة الأعمال المدنية المعقدة وخطورة بيئة العمل تطبق
              المؤسسة أقصى معايير السلامة التي تضمن الحد الأدنى من حوادث وإصابات
              العمل
            </p>
          </div>
          <div className="about intro">
            <div className="figure">
              <img src={img1} alt="icon" />
              <button className="btn">من نحن</button>
            </div>
            <div className="caption">
              <h1>حول مؤسسة رؤى الآفاق</h1>
              <p>
                يمثل نظام إدارة المٌعدات جزءا أساسيا من القدرة التنافسية المميزة
                لمؤسسة رؤى الآفاق مما يساعد على الحد من إهدار الوقت. يعتمد هذا
                النظام على العناصر الآتية:
              </p>
              <p>• تطوير الملحقات الخاصة بالمُعدات وشراء مُعدات متطورة.</p>
              <p>
                • إعداد قائمة مختصرة بأسماء كبار المصنعين العالميين ( سياسية
                الشراء بالمؤسسة).
              </p>
              <p>
                • سياسة إعادة تأهيل والتجديد الخاصة بالمُعدات والتي تكفل
                الاستفادة من أسطول المعدات طيلة عمرها.
              </p>
              <p>
                • يشمل الهيكل التنظيمي بالمؤسسة على تلبية احتياجات المشاريع
                وحالات الطوارئ، ومن أجل تفادي حدوث أية تأخير.
              </p>
              <p>
                • ورش الصيانة الثابتة والمتنقلة ، بالإضافة الى فرض برامج التشغيل
                والصيانة الميكانيكية.
              </p>
              <p>
                في عام 2021 ، أدى تأسيس مؤسسة رؤى الآفاق إلى تحويل هذا الحلم إلى
                واقع . لدينا فريق من المهندسين والفنيين المخضرمين هنا لتحويل
                رؤيتك إلى هياكل ملموسة.
              </p>
            </div>
          </div>
          <div className="about welcome">
            <div className="caption2">
              <h1>مرحبا بكم في مؤسسة رؤى الآفاق</h1>
            </div>
            <div className="figure">
              <img src={img2} alt="icon" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Intro
